import type { CloudConnectSubscription } from 'src/api/endpoints/cloudConnect.types';

function isOverdue(subscription: CloudConnectSubscription | null | undefined) {
  if (!subscription) return false;

  if (subscription.status === 'past_due') return true;

  if (!subscription.openInvoice?.dueDate) return false;

  const dueDate = new Date(subscription.openInvoice.dueDate);
  const now = new Date();

  return dueDate < now;
}

export const connectSubscriptionHelpers = {
  isOverdue,
};
